// extracted by mini-css-extract-plugin
export var buttonContainer = "_6v-1";
export var fontSizeSelect = "_6v-3";
export var formatSelect = "_6v-2";
export var formats = "_6v-4";
export var hidden = "_6v-5";
export var icon = "_6v-6";
export var select = "_6v-0";